window.addEventListener('load', () => {
  const scroller = document.querySelector('.konintodoke-top-certificates')
  const bar = document.querySelector('.js-konintodoke-certificates-scrollbar')

  if (!scroller || !bar) return

  const thumb = bar.querySelector('.konintodoke-top-certificates-scrollbar__thumb')

  if (!thumb) return

  const update = () => {
    const { scrollWidth, clientWidth, scrollLeft } = scroller

    if (scrollWidth <= clientWidth) {
      bar.style.display = 'none'
      return
    }

    bar.style.display = ''

    const thumbWidth = Math.max((clientWidth / scrollWidth) * 100, 8)
    const maxScroll = scrollWidth - clientWidth
    const maxThumbLeft = 100 - thumbWidth
    const left = maxScroll > 0 ? (scrollLeft / maxScroll) * maxThumbLeft : 0
    thumb.style.width = `${thumbWidth}%`
    thumb.style.left = `${left}%`
  }

  // スクロール毎の強制リフローを避けるためrAFで間引く(konintodoke-stamp.jsと同パターン)
  let ticking = false
  const requestUpdate = () => {
    if (ticking) return
    ticking = true
    requestAnimationFrame(() => {
      update()
      ticking = false
    })
  }

  update()
  scroller.addEventListener('scroll', requestUpdate, { passive: true })
  window.addEventListener('resize', requestUpdate, { passive: true })
  // lazy画像のロードやフォント適用でスクロール幅が後から変わるケースに追随する
  if (window.ResizeObserver) new ResizeObserver(requestUpdate).observe(scroller)
})
